export default __webpack_public_path__ + "static/media/multiDiscipline.b62cac17.jpg";